
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/integrations/oracle",
      function () {
        return require("private-next-pages/integrations/oracle.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/integrations/oracle"])
      });
    }
  